export const maintenancePlan = {
  name: "maintenancePlan",
  grid: {
    displayed: false,
    order: 23,
  },
  data: {
    active: false,
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Maintenance or calibration plan",
    displayed: false,
    disabled: true,
  },
};
